import { useContext } from 'react';
import useLocale from './use-locale';
import useShopForPageType from './use-shop-for-page-type';
import {
  bookingState,
  BookingStateCombinedState,
} from '../Pages/Booking/client-state/booking-state-context';
import {
  bookingEditState,
  BookingEditStateCombinedState,
} from '../Pages/BookingEdit/client-state/booking-edit-state-context';
import usePageType from './use-page-type';

export const useCustomRedirectUrl = () => {
  // Only used on booking and booking edit pages
  const { languageAsEnum } = useLocale();
  const shop = useShopForPageType();
  const pageType = usePageType();

  // This hook is currently only used on the booking and edit-booking pages
  const { state: stateBooking } = useContext(bookingState);
  const { state: stateBookingEdit } = useContext(bookingEditState);

  let state: BookingStateCombinedState['state'] | BookingEditStateCombinedState['state'];

  switch (pageType) {
    case 'booking': {
      state = stateBooking;
      break;
    }
    case 'edit-booking': {
      state = stateBookingEdit;
      break;
    }
    default: {
      state = stateBooking;
      break;
    }
  }

  const customPaymentSuccessPage =
    shop?.configuration?.paymentSuccessUrls?.[languageAsEnum];

  const redirectToCustomPage =
    shop?.configuration?.useCustomPaymentConfirmationPage && customPaymentSuccessPage;

  // only use the custom page if it's set up, and the useCustomPaymentConfirmationPage is enabled
  // otherwise, redirect to the shop's root - that is a safer option
  const redirectUrl = redirectToCustomPage
    ? `${customPaymentSuccessPage}?bookingId=${state.booking.id}&track=true`
    : shop?.websiteRoot || 'https://goboat.dk';

  // this console log might be useful for quick debugging
  // an invalid URL will prevent payments from being made
  console.log('to custom?', redirectToCustomPage, 'url', redirectUrl);
  return { redirectToCustomPage, redirectUrl };
};
